import { render, staticRenderFns } from "./dialogtable.vue?vue&type=template&id=6b8c76fc&"
import script from "./dialogtable.vue?vue&type=script&lang=js&"
export * from "./dialogtable.vue?vue&type=script&lang=js&"
import style0 from "./dialogtable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports